import { DeleteOutlined, FormOutlined } from '@ant-design/icons';
import { makeStyles } from '@material-ui/core';
import { Badge, Button, Popconfirm, Space, Table } from 'antd';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';


const useStyles = makeStyles(theme => ({
    table: {
        width: '100%',
        height: '100%',
        marginRight: theme.spacing(1)
    },
}))

/**
 * Cookies Table view
 */
const CookiesTableView = ({ cookies, selectCookie, loading, editCookie, deleteCookie, count, updateLimit, updatePage, page, limit, retryJob, setOrdering, onSelectTool }) => {
    const classes = useStyles()
    const [usernameFilters, setUsernameFilter] = useState([])
    const [toolFilters, setToolFilters] = useState([])

    useEffect(() => {
        // extract the unique creator names from cookies 
        if (cookies) {
            const names = [...new Set(cookies.map(j => j.created_by_name))]
            setUsernameFilter(names.map(n => ({ text: n, value: n })))

            const tools = [...new Set(cookies.map(j => j.tool_name))]
            setToolFilters(tools.map(n => ({ text: n, value: n })))

        }
    }, [cookies])

    const handleEditClick = record => {
        editCookie(record)
    }

    // cookies table schema
    const cookiesViewSchema = [
        {
            title: 'Id',
            dataIndex: 'id',
            key: 'id',
            sorter: (a, b) => a - b,
            render: (text, record) => <Button type="text" size="small">{text}</Button>
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            sorter: (a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()),
            render: (text, record) =>
                <span className={classes.nameCell}>{text}</span>
        },
        {
            title: 'User',
            dataIndex: 'created_by_name',
            key: 'created_by_name',
            filters: usernameFilters,
            onFilter: (value, record) => record.created_by_name.indexOf(value) === 0
        },
        {
            key: 'acc_type',
            title: 'Account Type',
            dataIndex: 'acc_type',
            filters: toolFilters,
            onFilter: (value, record) => record.tool_name.indexOf(value) === 0,
            sorter: (a, b) => a.tool_name.toLowerCase().localeCompare(b.tool_name.toLowerCase()),
            render: (text, record) => 
                <span className={classes.nameCell}>{text}</span> 
        },
        {
            key: 'is_active',
            title: 'Status',
            dataIndex: 'is_active',
            render: (is_active) => 
            <Space>
                <Badge
                    className="site-badge-count-109"
                    count={is_active? "Active": "Inactive"}
                    style={{ backgroundColor: is_active? "#52c41a": "" }}
                />
            </Space>
        },
        {

            title: 'Demerits',
            dataIndex: 'demerit',
            key: 'demerit'
        },
        {
            title: 'Updated Date',
            dataIndex: 'updated_at',
            key: 'updated_at',
            render: updated_at => (moment(updated_at).format("YYYY-MM-DD HH:mm")),
        },
        {
            title: 'Last Updated',
            dataIndex: 'last_update',
            key: 'last_update',
            render: last_update => (
                moment(last_update).format("YYYY-MM-DD HH:mm"))

        },
        {
            title: 'Created Date',
            dataIndex: 'created_at',
            key: 'created_at',
            render: created_at => (
                moment(created_at).format("YYYY-MM-DD HH:mm"))
        },
        {
            title: 'Actions',
            key: 'actions',
            render: (_, record) => {

                return (
                    <Space>
                        <Button type='primary' size='small' onClick={() => editCookie(record)}  icon={<FormOutlined />} />
                        <Popconfirm
                            title="Are you sure to delete this cookie?"
                            onConfirm={() => deleteCookie(record)}
                            okText="Yes"
                            cancelText="No"
                        >
                            <Button danger size='small'  icon={<DeleteOutlined />} />
                        </Popconfirm>
                       
                    </Space>
                );
            }
        }

    ]

    const changePage = (page, _) => {
        updatePage(page);
    }

    const changeSize = (page, size) => {
        updateLimit(size)
    }

    const handleTableChange = (pagination, filters, sorter) => {
        const field = sorter.field;
        const order = sorter.order;

        if (field && order) {
            const ordering = order === "descend" ? `-${field}` : field;
            setOrdering(ordering);
        }
    }


    return <Table
        columns={cookiesViewSchema}
        size='small'
        dataSource={cookies}
        className={classes.table}
        loading={loading}
        onChange={handleTableChange}
        pagination={{
            onChange: changePage,
            onShowSizeChange: changeSize,
            showSizeChanger: true,
            total: count,
            current: page,
            pageSize: limit,
        }}
    />
}

CookiesTableView.propTypes = {
    /** List of fetched cookies */
    cookies: PropTypes.array,
    /** Callback for job selection */
    selectJob: PropTypes.func,
    /** Show edit cookie drawer */
    editCookie: PropTypes.func,
    /** Callback for job selection */
    stopJob: PropTypes.func,
    /** Control table loader */
    loading: PropTypes.bool
}

export default CookiesTableView
